// Sim card activation related
import { createAction } from 'redux-actions'

import {
  EMPTY_SIMS_FETCH,
  EMPTY_SIMS_RECEIVE,
  NEW_SUBSCRIPTION,
  FREE_NUMBERS_FETCH,
  FREE_NUMBERS_RECEIVE,
  NEW_SUBSCRIPTION_FINISHED,
  ABLE_TO_ACTIVATE_FETCH,
  ABLE_TO_ACTIVATE_RECEIVE,
} from './constants'

export const sendNewSub = createAction(NEW_SUBSCRIPTION, (data, subscriptionNumber, accountType) => ({
  ...data,
  subscriptionNumber,
  accountType,
}));

export const fetchEmptySims = createAction(EMPTY_SIMS_FETCH, (id) => ({
  id,
}));

export const receiveEmptySims = createAction(EMPTY_SIMS_RECEIVE, (emptySims) => ({
  emptySims,
}));

export const fetchFreeNumbers = createAction(FREE_NUMBERS_FETCH);

export const receiveFreeNumbers = createAction(FREE_NUMBERS_RECEIVE, (freeNumbers) => ({
  freeNumbers,
}));

export const sendNewSubFinished = createAction(NEW_SUBSCRIPTION_FINISHED);

export const fetchAbleToActivate = createAction(ABLE_TO_ACTIVATE_FETCH, (id) => ({
  id,
}));

export const receiveAbleToActivate = createAction(ABLE_TO_ACTIVATE_RECEIVE, (ableToActivate) => ({
  ableToActivate,
}));
